import './ContentBuilderTemplate.scss';
import './ContentBuilderTemplate108.scss';

import React from 'react';
import { usePropsHandler } from '../../EventInterceptor/usePropsHandler';
import { cnContentBuilderTemplate } from './index';
import { Grid, GridItem } from '@dataartdev/uikit/Grid';
import { cn } from '../../../utils/bem';
import { Typography } from '@dataartdev/uikit/Typography';
import { Button } from '@dataartdev/uikit/Button';
import { IconArrowRight } from '@dataartdev/uikit/IconArrowRight';

import { IRoot108 } from './models/CTI_108.props';
import { prepareButtonAttrs } from '../../../utils/prepareButtonAttrs';
import { CtaScrollerBtn } from '../../CtaScrollerBtn';

const cnBentoSection = cn('BentoSection');
const cnBentoCard = cn('BentoCard');
const cnBentoImage = cn('BentoImage');

export const ContentBuilderTemplate: React.FC<IRoot108> = props => {
  const { type, title, link, row, row2, contentId } = usePropsHandler(
    cnContentBuilderTemplate(),
    props
  );

  const typeNumber = type.toString();
  const buttonAttr = prepareButtonAttrs(
    link?.link,
    link?.title,
    link?.targetBlank
  );

  interface ColumnConfiguration {
    [key: number]: {
      mobileCol: number;
      tabletCol: number;
      desktopCol: number;
    };
  }

  const columnConfigurations: ColumnConfiguration = {
    1: { mobileCol: 12, tabletCol: 6, desktopCol: 3 },
    2: { mobileCol: 12, tabletCol: 12, desktopCol: 6 },
    3: { mobileCol: 12, tabletCol: 6, desktopCol: 9 },
  };

  return (
    <div
      className={cnContentBuilderTemplate({ type: typeNumber })}
      id={contentId}
    >
      <div className={cnBentoSection()}>
        <Grid
          breakpoints={{
            desktop: { cols: 12, gap: 'xl' },
            tablet: { cols: 12, gap: 'xl' },
            mobile: { cols: 12, gap: 'xl' },
          }}
        >
          <GridItem
            breakpoints={{
              desktop: { col: 10 },
              tablet: { col: 12 },
              mobile: { col: 12 },
            }}
          >
            {title && (
              <Typography.Title size="lg" as="h2" parse>
                {title}
              </Typography.Title>
            )}
          </GridItem>
          <GridItem
            breakpoints={{
              desktop: { col: 12 },
              tablet: { col: 12 },
              mobile: { col: 12 },
            }}
          >
            <Grid
              breakpoints={{
                desktop: { cols: 12, gap: 'xl' },
                tablet: { cols: 12, gap: 'xl' },
                mobile: { cols: 12, gap: 'xl' },
              }}
            >
              {row &&
                row.length > 0 &&
                row.map(item => {
                  const {
                    mobileCol,
                    tabletCol,
                    desktopCol,
                  } = columnConfigurations[item.size];
                  const buttonAttr = prepareButtonAttrs(
                    item?.link?.link,
                    item?.link?.title,
                    item?.link?.targetBlank
                  );
                  return (
                    <GridItem
                      key={item.id}
                      breakpoints={{
                        desktop: { col: desktopCol },
                        tablet: { col: tabletCol },
                        mobile: { col: mobileCol },
                      }}
                    >
                      {item?.picture ? (
                        <div
                          className={cnBentoImage()}
                          style={{
                            backgroundImage: `url(${item.picture.urlWebp}.)`,
                          }}
                        />
                      ) : (
                        <div className={cnBentoCard()}>
                          <div className={cnBentoCard('Top')}>
                            {item?.title && (
                              <Typography.Title
                                parse
                                className={cnBentoCard('Title')}
                                as="h3"
                                size="md"
                              >
                                {item.title}
                              </Typography.Title>
                            )}
                            {item?.text && (
                              <Typography.Text
                                className={cnBentoCard('Text')}
                                as="p"
                                size="m"
                              >
                                {item.text}
                              </Typography.Text>
                            )}
                          </div>
                          <Button
                            className={cnBentoCard('Link')}
                            view="link-secondary"
                            iconRight={IconArrowRight}
                            {...buttonAttr}
                          />
                        </div>
                      )}
                    </GridItem>
                  );
                })}

              {/*SECOND ROW*/}

              {row2 &&
                row2.length > 0 &&
                row2.map(item => {
                  const {
                    mobileCol,
                    tabletCol,
                    desktopCol,
                  } = columnConfigurations[item.size];
                  const buttonAttr = prepareButtonAttrs(
                    item?.link?.link,
                    item?.link?.title,
                    item?.link?.targetBlank
                  );
                  return (
                    <GridItem
                      key={item.id}
                      breakpoints={{
                        desktop: { col: desktopCol },
                        tablet: { col: tabletCol },
                        mobile: { col: mobileCol },
                      }}
                    >
                      {item?.picture ? (
                        <div
                          className={cnBentoImage()}
                          style={{
                            backgroundImage: `url(${item.picture.urlWebp}.)`,
                          }}
                        />
                      ) : (
                        <div className={cnBentoCard()}>
                          <div className={cnBentoCard('Top')}>
                            {item?.title && (
                              <Typography.Title
                                parse
                                className={cnBentoCard('Title')}
                                as="h3"
                                size="md"
                              >
                                {item.title}
                              </Typography.Title>
                            )}
                            {item?.text && (
                              <Typography.Text
                                className={cnBentoCard('Text')}
                                as="p"
                                size="m"
                              >
                                {item.text}
                              </Typography.Text>
                            )}
                          </div>
                          {Object.keys(buttonAttr).length > 0 && (
                            <Button
                              className={cnBentoCard('Link')}
                              view="link-secondary"
                              iconRight={IconArrowRight}
                              {...buttonAttr}
                            />
                          )}
                        </div>
                      )}
                    </GridItem>
                  );
                })}
            </Grid>
          </GridItem>
          <GridItem
            breakpoints={{
              desktop: { col: 12 },
              tablet: { col: 12 },
              mobile: { col: 12 },
            }}
          >
            {Object.keys(buttonAttr).length > 0 && (
              <>
                {'isCTA' in buttonAttr ? (
                  <CtaScrollerBtn
                    view="secondary"
                    className={cnBentoSection('Cta')}
                    {...buttonAttr}
                  />
                ) : (
                  <Button
                    view="secondary"
                    iconRight={IconArrowRight}
                    className={cnBentoSection('Cta')}
                    {...buttonAttr}
                  />
                )}
              </>
            )}
          </GridItem>
        </Grid>
      </div>
    </div>
  );
};

export default ContentBuilderTemplate;
